import { useState } from "react";
import { ChevronLeft, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";

const AddColony = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [colonyName, setColonyName] = useState("");
  const [description, setDescription] = useState("");

  const handleCreateColony = () => {
    if (!colonyName.trim()) {
      toast({
        title: "Error",
        description: "Please enter a colony name.",
        variant: "destructive",
      });
      return;
    }

    toast({
      title: "Success",
      description: `Colony "${colonyName}" created successfully!`,
    });
    
    // Navigate to the new colony's chat
    navigate("/chat");
  };

  return (
    <div className="ios-edge-container min-h-screen bg-background safe-area-top safe-area-bottom">
      {/* Header */}
      <div className="flex items-center justify-between h-14 ios-content-padding border-b border-ios-separator bg-background">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/")}
          className="p-2 hover:bg-ios-surface-secondary"
        >
          <ChevronLeft size={24} className="text-ios-blue" />
        </Button>
        <h1 className="ios-headline text-foreground">New Colony</h1>
        <div className="w-10" />
      </div>

      <div className="flex-1 ios-content-padding pt-8">
        {/* Form */}
        <div className="space-y-6">
          <div>
            <label className="ios-footnote text-muted-foreground uppercase tracking-wide mb-2 block">
              Colony Name
            </label>
            <Input
              value={colonyName}
              onChange={(e) => setColonyName(e.target.value)}
              placeholder="Enter colony name"
              className="h-11 bg-ios-surface border border-ios-separator rounded-lg ios-body"
            />
          </div>

          <div>
            <label className="ios-footnote text-muted-foreground uppercase tracking-wide mb-2 block">
              Description (Optional)
            </label>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your colony's purpose"
              className="h-11 bg-ios-surface border border-ios-separator rounded-lg ios-body"
            />
          </div>

          {/* Create Button */}
          <div className="pt-4">
            <Button
              onClick={handleCreateColony}
              className="ios-button-large w-full bg-ios-blue hover:bg-ios-blue/90 text-white border-0"
            >
              <Plus size={20} className="mr-2" />
              Create Colony
            </Button>
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-12 p-4 bg-ios-surface-secondary rounded-xl">
          <h3 className="ios-subheadline font-medium text-foreground mb-2">
            About Colonies
          </h3>
          <p className="ios-caption-1 text-muted-foreground">
            A colony is a collection of AI brains working together. Each colony can have multiple specialized brains for different tasks.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddColony;